import { Component, DestroyRef, effect, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmLabelImports } from '@spartan-ng/helm/label';
import { toast } from 'ngx-sonner';
import { v7 as uuidv7 } from 'uuid';

import { SidepanelService } from '../../shared/components/sidepanel/sidepanel.service';
import { ToastrSuccessComponent } from '../../shared/components/toastr/toastr-success.component';
import { LabelRequiredDirective } from '../../shared/directives/label-required.directive';
import { Modalité } from '../models/modalité.model';
import { ModalitéStore } from '../store/modalité.store';

@Component({
  selector: 'app-form-modalite',
  imports: [ReactiveFormsModule, HlmInputImports, HlmLabelImports, LabelRequiredDirective],
  templateUrl: './form-modalité.component.html',
})
export class FormModalitéComponent implements OnInit {
  readonly #fb = inject(FormBuilder);
  readonly #sidepanelService = inject(SidepanelService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #store = inject(ModalitéStore);

  readonly idCartographie = input.required<string>();
  readonly modalite = input.required<Modalité>();

  form = this.#fb.group({
    nom: ['', Validators.required],
  });

  constructor() {
    effect(() => this.nom.setValue(this.modalite().nom));
  }

  ngOnInit(): void {
    this.#sidepanelService.submit.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => this.onSubmit());
  }

  onSubmit() {
    const toastrId = uuidv7();
    this.#store.modifier({
      id: this.modalite().id,
      data: { nom: this.nom.value },
      next: () => {
        toast.custom(ToastrSuccessComponent, {
          componentProps: { message: 'Modification de la modalité réussie', id: toastrId },
          id: toastrId,
        });
        this.#sidepanelService.close();
        this.#store.charger(this.idCartographie());
      },
    });
  }

  get nom() {
    return this.form.get('nom') as FormControl<string>;
  }
}
